import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class EnumListService {
  //Afficher List Objectifs
  AfficherListObjectifs() {
    return api.get(UtilsUrl.marketingURL() + "/EnumList/getObjectifs");
  }

  //Afficher List Types
  AfficherListTypes() {
    return api.get(UtilsUrl.marketingURL() + "/EnumList/getTypes");
  }

  //Afficher List CanalDiffusion
  AfficherListCanalDiffusion() {
    return api.get(
      UtilsUrl.marketingURL() + "/EnumList/getCanalDiffusionsCampagne"
    );
  }

  //Afficher List Statut
  AfficherListStatus() {
    return api.get(UtilsUrl.marketingURL() + "/EnumList/getStatus");
  }

  //Afficher List Genre
  AfficherListGenres() {
    return api.get(UtilsUrl.marketingURL() + "/EnumList/getGenres");
  }
}

export default new EnumListService();
